export const Scouters = [
    "Roxanna",
    "Avik",
    "Sahil",
    "Lakshya",
    "Arnav",
    "Arman",
    "Theadin",
    "Jahnvi",
    "Alexander",
    "Michael",
    "Benjamin",
    "Tyrus",
    "Leo",
    "Andrea",
    "Eliot",
    "Kyle",
    "Iliana",
    "Alisa",
    "Paola Gomez",
    "Ellery",
    "William",
    "Cole",
    "Eric H",
    "Ian",
    "Johann",
    "Eric J",
    "Hajin",
    "Nova",
    "Angie",
    "Henry",
    "Ryan",
    "Claire",
    "Cameron",
    "Elisa",
    "Saara",
    "Shaurya",
    "Ashir",
    "Piper",
    "Nicole",
    "Mehaan",
    "James",
    "Kaushik",
    "Gavin",
    "Anirudh",
    "Brandon",
    "Connor",
    "Adam",
    "Anthony"
]